import React from 'react';

function OffensiveCloudSecurity() {
  return (
    <div className="container">
      <h1>Offensive Cloud Security</h1>
      <p>Details about Offensive Cloud Security. 🚧</p>
    </div>
  );
}

export default OffensiveCloudSecurity;